import * as React from 'react';
import { DirectoryStoreState, Store } from '../../types';
import { ExtensionsList } from '../ExtensionList';
import { useMappedState } from 'redux-react-hook';
import { useCallback } from 'react';

export interface StorePreloadedProps {
  store: Store;
}

export const StorePreloaded: React.FC<StorePreloadedProps> = ({ store }) => {
  const isIntegrationUrl = useMappedState(
    useCallback((state: DirectoryStoreState) => !!state.queryString.integrationURL, [])
  );

  return (
    <React.Fragment>
      <h2 className="title">Store</h2>
      <div className="storeItem">
        <div className="storeItem-header">
          <div>
            {store.store} Tel:&nbsp;
            {isIntegrationUrl ? store.number : <a href={`tel:${store.number}`}>{store.number}</a>}
          </div>
          {store.store_api_uuid}
        </div>
        <ExtensionsList storeId={store.id} sloc={store.sloc} number={store.number} />
      </div>
    </React.Fragment>
  );
};
